<template>
  <div class="view">
    <div class="content">
      <better-scroll class="nav" :scrollX="true">
        <div class="wrapper">
          <span
            class="item"
            v-for="(item,index) in navList1"
            :key="index"
            :class="{'item_active':item.select}"
            @click="changeData(item,index)"
          >{{item.name}}</span>
        </div>
      </better-scroll>
      <div class="sort" @click="handleReserve">
            <img class="iconSize" src="../../../assets/image/ic_px@2x.png" alt v-show="isShow" />
            <img class="iconSize" src="../../../assets/image/ic_d_px@2x.png" alt  v-show="!isShow"/>
      </div>
    </div>

      <div v-if="dataList.length">
        <van-list
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            @load="onLoad"
            class="wrapperList"
            >
          <div class="list" v-for="(item,index) in dataList " :key="index">
            <div class="index">{{(index+1)}}、</div>
            <div class="name">{{item.name}}</div>
            <div class="score" v-if="item.score === '' || !item.score">待评</div>
            <div class="score" v-else>{{item.score}}分</div>
          </div>
        </van-list>
      </div>

      <div class="noData" v-else>
        <div class="noDataBox">
          <div class="noDataImg">
            <img src="../../../assets/image/ic_wuxingxi@3x.png" alt="">
          </div>
          <div class="prompt">暂无数据</div>
        </div>
      </div>

  </div>
</template>
<script>
    import betterScroll from '../../components/base/betterScroll';
    import api from '../../../service/modules/integrity'
    export default {
        name: 'tabs',
        components: {
            'better-scroll': betterScroll
        },
        props: {},
        data () {
            return {
                finishedText: '',
                isShow: false,
                loading: false,
                finished: false,
                navList1: [],
                dataList: [],
                changeCode: '',
                EnterpriseRankingFlag: false, // 正序反序
                pageIndex: 1,
                pageSize: 20,
                regionCode:this.$route.query.cityCode||'530000', // 区域code
                ind: this.$route.query.ind, // tab 默认值
            };
        },
        created () {
            // this.regionCode = JSON.parse(localStorage.getItem('cityCode')) || '530000'
            this.getTitle()
        },
        methods: {
            onLoad () {
                this.getList()
            },
            // 获取标题
            getTitle () {
                api.industryCategory().then(res => {
                    if (res.ret === 0) {
                        for (let i in res.data) {
                            res.data[i].select = false;
                        }
                        res.data[this.ind].select = true
                        this.navList1 = res.data;
                        this.changeCode = res.data[this.ind].code
                        this.getList()
                    }
                });
            },
            changeData (item) {
                console.log(item)
                this.pageIndex = 1
                this.dataList = []
                for (let i = 0; i < this.navList1.length; i++) {
                    this.navList1[i].select = false;
                }
                item.select = true;
                // console.log(1000, item)
                this.changeCode = item.code
                this.getList()
            },
            // 排序按钮
            handleReserve () {
                this.isShow = !this.isShow
                this.pageIndex = 1
                this.dataList = []
                this.getList()
            },
            getList () {
                let parm = {
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize,
                    regionCode: this.regionCode,
                    industryCategory: this.changeCode,
                    asc: this.isShow
                };
                api.enterpriseRanking(parm).then(res => {
                    if (res.ret === 0) {
                        let arr = res.data.list
                        if (arr.length > 0) {
                            this.pageIndex++
                            this.dataList = this.dataList.concat(arr)
                            this.finished = false
                        } else {
                            this.finished = true
                            this.finishedText = '我也是有底线的'
                        }
                        this.loading = false
                    }
                })
            }
        }
    };
</script>

<style lang="less" scoped>
.view {
  background: #fbfbfb;
  .content {
    width: 100%;
    padding: 10px 10px 6px 0;
    box-sizing: border-box;
    .nav {
    overflow: hidden;
    position: relative;
    background-color: #fbfbfb;
    padding-bottom: 16px;
      width: 340px;
      height: 40px;
      .wrapper {
        white-space: nowrap;
        position: absolute;
        padding-right: 14px;
        .item {
          margin: 12px;
          padding-bottom: 6px;
          display: inline-block;
          
          // border-bottom: 2px solid @base-color;
          font-size: 14px;
        }
        .item_active {
          border-bottom: 2px solid @base-color;
          color: @base-color;
          font-weight: 500;
        }
      }
    }
  }
  .noData{
    height: 600px;
    margin-top: 216px;
      display: flex;
      justify-content: center;
    .noDataBox{
      width: 200px;
      height: 200px;
      .noDataImg{
      margin: 0 auto;
        width: 72px;
        height: 64px;
      }
      .prompt{
        text-align: center;
        color: #999999;
      }
    }
  }
  .wrapperList{
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.04);
    border-radius: 3px;
    margin: 0 12px 12px 12px;
    &>div:nth-last-child(3){
      padding-bottom: 8px;
    }
    .list {
      overflow: hidden;
      background-color: #ffffff;
      font-size: 12px;
      color: rgba(102, 102, 102, 1);
      line-height: 28px;
      // margin-left: 12px;
      // margin-right: 12px;
      padding: 8px 12px 0 12px;
      .index {
        float: left;
      }
      .name {
        float: left;
        max-width: 220px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space:nowrap;
      }
      .score {
        float: right;
      }
    }
  }
  .sort{
      position: absolute;
        height: 14px;
        width: 12px;
        right: 12px;
        top:23px;
        img{
            width: 14px;
            height: 12px;
        }
  }
}
</style>
